export default {
  "states": {
    "created": "No Solicitado",
    "pending": "Pendiente",
    "edited": "Editado",
    "accepted": "Aceptado",
    "rejected": "Rechazado"
  },
  "months": {
    "january": "enero",
    "february": "febrero",
    "march": "marzo",
    "april": "abril",
    "may": "mayo",
    "june": "junio",
    "july": "julio",
    "august": "agosto",
    "september": "septiembre",
    "october": "octubre",
    "november": "noviembre",
    "dicember": "diciembre"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/escondida/flows/index.js